import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { Badge } from '@/components/ui/Badge';
import { useDashboardStats } from '@/hooks/useAdminMonitoring';
import { formatNumber, formatPercentage } from '@/utils/formatters';
import { Cpu, CheckCircle, XCircle, Clock } from 'lucide-react';

export function AutomationStatusCard() {
  const { data } = useDashboardStats();
  const automations = data?.automations;

  return (
    <Card>
      <CardHeader title="Automatisations" icon={<Cpu className="h-4 w-4" />} />
      <CardContent>
        <div className="space-y-2">
          <div className="flex items-center justify-between rounded-xl bg-neutral-100 p-3 transition-colors duration-200 hover:bg-neutral-200/70 dark:bg-neutral-800/50 dark:hover:bg-neutral-800/70">
            <div className="flex items-center gap-2.5">
              <Cpu className="h-4 w-4 text-primary-400" />
              <span className="text-sm text-neutral-700 dark:text-neutral-300">En cours</span>
            </div>
            <Badge variant="info">{formatNumber(automations?.running)}</Badge>
          </div>
          <div className="flex items-center justify-between rounded-xl bg-neutral-100 p-3 transition-colors duration-200 hover:bg-neutral-200/70 dark:bg-neutral-800/50 dark:hover:bg-neutral-800/70">
            <div className="flex items-center gap-2.5">
              <Clock className="h-4 w-4 text-warning-400" />
              <span className="text-sm text-neutral-700 dark:text-neutral-300">En attente</span>
            </div>
            <Badge variant="warning">{formatNumber(automations?.pending)}</Badge>
          </div>
          <div className="flex items-center justify-between rounded-xl bg-neutral-100 p-3 transition-colors duration-200 hover:bg-neutral-200/70 dark:bg-neutral-800/50 dark:hover:bg-neutral-800/70">
            <div className="flex items-center gap-2.5">
              <CheckCircle className="h-4 w-4 text-success-400" />
              <span className="text-sm text-neutral-700 dark:text-neutral-300">Taux de succès</span>
            </div>
            <Badge variant="success">{formatPercentage(automations?.successRate)}</Badge>
          </div>
          <div className="flex items-center justify-between rounded-xl bg-neutral-100 p-3 transition-colors duration-200 hover:bg-neutral-200/70 dark:bg-neutral-800/50 dark:hover:bg-neutral-800/70">
            <div className="flex items-center gap-2.5">
              <XCircle className="h-4 w-4 text-danger-400" />
              <span className="text-sm text-neutral-700 dark:text-neutral-300">Échecs (24h)</span>
            </div>
            <Badge variant="danger">{formatNumber(automations?.failed24h)}</Badge>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
